// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as GetHelpRouteImport } from './routes/get-help'
import { Route as FreeConsultationRouteImport } from './routes/free-consultation'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EditorialStandardsRouteImport } from './routes/editorial-standards'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AyudaRouteImport } from './routes/ayuda'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServiceAreasIndexRouteImport } from './routes/service-areas.index'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as AboutIndexRouteImport } from './routes/about.index'
import { Route as ServiceAreasSlugRouteImport } from './routes/service-areas.$slug'
import { Route as ResourcesNoticeLookupRouteImport } from './routes/resources.notice-lookup'
import { Route as ResourcesIrsFreshStartProgramGuideRouteImport } from './routes/resources.irs-fresh-start-program-guide'
import { Route as ResourcesHowMuchDoesTaxResolutionCostRouteImport } from './routes/resources.how-much-does-tax-resolution-cost'
import { Route as ResourcesHowLongDoesTaxResolutionTakeRouteImport } from './routes/resources.how-long-does-tax-resolution-take'
import { Route as ResourcesGlossaryRouteImport } from './routes/resources.glossary'
import { Route as ResourcesCpaVsTaxAttorneyForIrsHelpRouteImport } from './routes/resources.cpa-vs-tax-attorney-for-irs-help'
import { Route as Resources7SecretsGuideRouteImport } from './routes/resources.7-secrets-guide'
import { Route as PGetHelpRouteImport } from './routes/p.get-help'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AboutFranklinSofiRouteImport } from './routes/about.franklin-sofi'
import { Route as ServicesCategorySlugIndexRouteImport } from './routes/services.$categorySlug.index'
import { Route as ResourcesIrsNoticesIndexRouteImport } from './routes/resources.irs-notices.index'
import { Route as ResourcesIrsFormsIndexRouteImport } from './routes/resources.irs-forms.index'
import { Route as ServicesCategorySlugServiceSlugRouteImport } from './routes/services.$categorySlug.$serviceSlug'
import { Route as ResourcesIrsNoticesNoticeIdRouteImport } from './routes/resources.irs-notices.$noticeId'
import { Route as ResourcesIrsFormsSlugRouteImport } from './routes/resources.irs-forms.$slug'

const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ScheduleRoute = ScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ResultsRoute = ResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const GetHelpRoute = GetHelpRouteImport.update({
            id: '/get-help',path: '/get-help',getParentRoute: () => rootRouteImport
          })
const FreeConsultationRoute = FreeConsultationRouteImport.update({
            id: '/free-consultation',path: '/free-consultation',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EditorialStandardsRoute = EditorialStandardsRouteImport.update({
            id: '/editorial-standards',path: '/editorial-standards',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AyudaRoute = AyudaRouteImport.update({
            id: '/ayuda',path: '/ayuda',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServiceAreasIndexRoute = ServiceAreasIndexRouteImport.update({
            id: '/service-areas/',path: '/service-areas/',getParentRoute: () => rootRouteImport
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const ServiceAreasSlugRoute = ServiceAreasSlugRouteImport.update({
            id: '/service-areas/$slug',path: '/service-areas/$slug',getParentRoute: () => rootRouteImport
          })
const ResourcesNoticeLookupRoute = ResourcesNoticeLookupRouteImport.update({
            id: '/resources/notice-lookup',path: '/resources/notice-lookup',getParentRoute: () => rootRouteImport
          })
const ResourcesIrsFreshStartProgramGuideRoute = ResourcesIrsFreshStartProgramGuideRouteImport.update({
            id: '/resources/irs-fresh-start-program-guide',path: '/resources/irs-fresh-start-program-guide',getParentRoute: () => rootRouteImport
          })
const ResourcesHowMuchDoesTaxResolutionCostRoute = ResourcesHowMuchDoesTaxResolutionCostRouteImport.update({
            id: '/resources/how-much-does-tax-resolution-cost',path: '/resources/how-much-does-tax-resolution-cost',getParentRoute: () => rootRouteImport
          })
const ResourcesHowLongDoesTaxResolutionTakeRoute = ResourcesHowLongDoesTaxResolutionTakeRouteImport.update({
            id: '/resources/how-long-does-tax-resolution-take',path: '/resources/how-long-does-tax-resolution-take',getParentRoute: () => rootRouteImport
          })
const ResourcesGlossaryRoute = ResourcesGlossaryRouteImport.update({
            id: '/resources/glossary',path: '/resources/glossary',getParentRoute: () => rootRouteImport
          })
const ResourcesCpaVsTaxAttorneyForIrsHelpRoute = ResourcesCpaVsTaxAttorneyForIrsHelpRouteImport.update({
            id: '/resources/cpa-vs-tax-attorney-for-irs-help',path: '/resources/cpa-vs-tax-attorney-for-irs-help',getParentRoute: () => rootRouteImport
          })
const Resources7SecretsGuideRoute = Resources7SecretsGuideRouteImport.update({
            id: '/resources/7-secrets-guide',path: '/resources/7-secrets-guide',getParentRoute: () => rootRouteImport
          })
const PGetHelpRoute = PGetHelpRouteImport.update({
            id: '/p/get-help',path: '/p/get-help',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AboutFranklinSofiRoute = AboutFranklinSofiRouteImport.update({
            id: '/about/franklin-sofi',path: '/about/franklin-sofi',getParentRoute: () => rootRouteImport
          })
const ServicesCategorySlugIndexRoute = ServicesCategorySlugIndexRouteImport.update({
            id: '/services/$categorySlug/',path: '/services/$categorySlug/',getParentRoute: () => rootRouteImport
          })
const ResourcesIrsNoticesIndexRoute = ResourcesIrsNoticesIndexRouteImport.update({
            id: '/resources/irs-notices/',path: '/resources/irs-notices/',getParentRoute: () => rootRouteImport
          })
const ResourcesIrsFormsIndexRoute = ResourcesIrsFormsIndexRouteImport.update({
            id: '/resources/irs-forms/',path: '/resources/irs-forms/',getParentRoute: () => rootRouteImport
          })
const ServicesCategorySlugServiceSlugRoute = ServicesCategorySlugServiceSlugRouteImport.update({
            id: '/services/$categorySlug/$serviceSlug',path: '/services/$categorySlug/$serviceSlug',getParentRoute: () => rootRouteImport
          })
const ResourcesIrsNoticesNoticeIdRoute = ResourcesIrsNoticesNoticeIdRouteImport.update({
            id: '/resources/irs-notices/$noticeId',path: '/resources/irs-notices/$noticeId',getParentRoute: () => rootRouteImport
          })
const ResourcesIrsFormsSlugRoute = ResourcesIrsFormsSlugRouteImport.update({
            id: '/resources/irs-forms/$slug',path: '/resources/irs-forms/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AdminRoute: AdminRoute,AyudaRoute: AyudaRoute,ContactRoute: ContactRoute,DisclaimerRoute: DisclaimerRoute,EditorialStandardsRoute: EditorialStandardsRoute,FaqRoute: FaqRoute,FreeConsultationRoute: FreeConsultationRoute,GetHelpRoute: GetHelpRoute,HowItWorksRoute: HowItWorksRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResultsRoute: ResultsRoute,ReviewsRoute: ReviewsRoute,ScheduleRoute: ScheduleRoute,TermsRoute: TermsRoute,ThankYouRoute: ThankYouRoute,AboutFranklinSofiRoute: AboutFranklinSofiRoute,BlogSlugRoute: BlogSlugRoute,PSlugRoute: PSlugRoute,PGetHelpRoute: PGetHelpRoute,Resources7SecretsGuideRoute: Resources7SecretsGuideRoute,ResourcesCpaVsTaxAttorneyForIrsHelpRoute: ResourcesCpaVsTaxAttorneyForIrsHelpRoute,ResourcesGlossaryRoute: ResourcesGlossaryRoute,ResourcesHowLongDoesTaxResolutionTakeRoute: ResourcesHowLongDoesTaxResolutionTakeRoute,ResourcesHowMuchDoesTaxResolutionCostRoute: ResourcesHowMuchDoesTaxResolutionCostRoute,ResourcesIrsFreshStartProgramGuideRoute: ResourcesIrsFreshStartProgramGuideRoute,ResourcesNoticeLookupRoute: ResourcesNoticeLookupRoute,ServiceAreasSlugRoute: ServiceAreasSlugRoute,AboutIndexRoute: AboutIndexRoute,BlogIndexRoute: BlogIndexRoute,ResourcesIndexRoute: ResourcesIndexRoute,ServiceAreasIndexRoute: ServiceAreasIndexRoute,ServicesIndexRoute: ServicesIndexRoute,ResourcesIrsFormsSlugRoute: ResourcesIrsFormsSlugRoute,ResourcesIrsNoticesNoticeIdRoute: ResourcesIrsNoticesNoticeIdRoute,ServicesCategorySlugServiceSlugRoute: ServicesCategorySlugServiceSlugRoute,ResourcesIrsFormsIndexRoute: ResourcesIrsFormsIndexRoute,ResourcesIrsNoticesIndexRoute: ResourcesIrsNoticesIndexRoute,ServicesCategorySlugIndexRoute: ServicesCategorySlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)